import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Menu = createSvgIcon(
  <path fillRule="evenodd" clipRule="evenodd" d="M24 0H0V1H24V0ZM0 7H24V8H0V7ZM0 14H24V15H0V14Z" />,
  'Menu'
)

export default Menu
